import { useEffect } from 'react';
import { LocaleConfig } from 'react-native-calendars';
import { useSelector } from 'react-redux';

LocaleConfig.locales['zh'] = {
    monthNames: [
      '一月',
      '二月',
      '三月',
      '四月',
      '五月',
      '六月',
      '七月',
      '八月',
      '九月',
      '十月',
      '十一月',
      '十二月'
    ],
    monthNamesShort: [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月'
    ],
    dayNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    dayNamesShort: ['日', '一', '二', '三', '四', '五', '六'],
    today: "今天"
};

LocaleConfig.locales['en'] = {
    monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    monthNamesShort: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    today: "Today"
};

// react-native-calendars ships no data for these, so derive the names from Intl
// rather than keeping three more hand written tables in sync
const INTL_TAGS = {
    jp: 'ja',
    th: 'th',
    ind: 'id',
};

const makeLocale = (tag) => {
    const format = (options, date) => new Intl.DateTimeFormat(tag, { ...options, timeZone: 'UTC' }).format(date);

    const months = [...Array(12)].map((_, i) => new Date(Date.UTC(2021, i, 1)));
    // 2021-08-01 was a Sunday, which is the first day of the week for the calendar
    const days = [...Array(7)].map((_, i) => new Date(Date.UTC(2021, 7, 1 + i)));

    return {
        monthNames: months.map(d => format({ month: 'long' }, d)),
        monthNamesShort: months.map(d => format({ month: 'short' }, d)),
        dayNames: days.map(d => format({ weekday: 'long' }, d)),
        dayNamesShort: days.map(d => format({ weekday: 'short' }, d)),
        today: new Intl.RelativeTimeFormat(tag, { numeric: 'auto' }).format(0, 'day'),
    };
};

Object.keys(INTL_TAGS).forEach(locale => {
    try {
        LocaleConfig.locales[locale] = makeLocale(INTL_TAGS[locale]);
    } catch (error) {
        // no Intl support: the calendar falls back to english for this locale
    }
});

export const RNCalendarLocaleSetter = ({
    children,
}) => {
    const locale = useSelector(state => state.common.locale);

    useEffect(() => {
        if (locale === 'zht' || locale === 'zhs') {
            LocaleConfig.defaultLocale = 'zh';
        } else if (LocaleConfig.locales[locale]) {
            LocaleConfig.defaultLocale = locale;
        } else {
            LocaleConfig.defaultLocale = 'en';
        }
    }, [locale]);

    return children;
};